import React, { Component } from 'react';

import { App, Link, Navbar, NavRight, Page, Popup, Statusbar, View, Views } from 'framework7-react';

import { routes } from '../routes';
import '../css/f7override/Navbar.css';
import '../css/f7override/Page.css';
import '../css/f7override/Popup.css';
import '../css/f7override/Dialog.css';
import '../css/f7override/notch.css';
import '../css/f7override/Toast.css';
import { PopupController } from './popups/popupController';
import LoginPopup from './popups/loginPopup/LoginPopup';
import ResetPasswordPopup from './popups/resetPasswordPopup/ResetPasswordPopup';
import LeftPanel from 'components/LeftPanel.jsx';
import DashBoardPage from './pages/dashboardPage/DashBoardPage';
import listenForInteraction from '../utils/listenForInteraction';
import mainAPI from '../api/MainAPI';
import toasts from '../utils/toasts';
import StackTrace from 'stacktrace-js';
import ToastController from "./toasts/ToastController";
import vpnController from "../controllers/vpnController";
import offlineSyncController from "../controllers/offlineSyncController";

const MainViews = (props, context) => {
	setTimeout(() => {
		if (window.StatusBar) {
			window.StatusBar.styleLightContent();

			// window.StatusBar.backgroundColorByHexString('#284677')
		}
	}, 3000);

	return (
		<Views id={"main-views"}>
			<View id="main-view" navbarThrough dynamicNavbar={true} main url="/" stackPages>
				<DashBoardPage />
			</View>
		</Views>
	);
};

const AppPopup = () => (
	<Popup id="popup">
		<View navbarFixed>
			<Page>
				<Navbar title="Popup">
					<NavRight>
						<Link closePopup>Close</Link>
					</NavRight>
				</Navbar>
			</Page>
		</View>
	</Popup>
);

class APP extends Component {
	componentDidCatch = (error, info) => {
		const correlationId = Date.now();
		StackTrace.fromError(error).then((updated) => {
			mainAPI.error_log.create({
				type: 'App.componentDidCatch',
				message: correlationId + localStorage.token + JSON.stringify(updated)
			});
		});
		mainAPI.error_log.create({
			type: 'App.componentDidCatch',
			message: correlationId + localStorage.token + JSON.stringify(error) + JSON.stringify(info)
		});
	};
	appResume = async () => {
		await mainAPI.user.get();
		await this.checkVpnStatus();
		await offlineSyncController.start();
	};
	checkVpnStatus = async () => {
		const vpnConnected = await vpnController.isVpnConnected();
		if (vpnConnected) {
			this.showThrottledVpnWarning();
		}
	};
	showThrottledVpnWarning = () => {
		const now = Date.now();
		const oneDay = 24 * 60 * 60 * 1000; // 1 day in milliseconds
		const oneMonth = 30 * 24 * 60 * 60 * 1000; // 30 days in milliseconds

		// Get stored timestamps or initialize
		let vpnWarningTimestamps = [];
		try {
			const stored = localStorage.getItem('vpnWarningTimestamps');
			if (stored) {
				vpnWarningTimestamps = JSON.parse(stored);
			}
		} catch (e) {
			console.error('Error reading vpnWarningTimestamps from localStorage:', e);
		}

		// Filter out timestamps older than 30 days to keep storage clean
		vpnWarningTimestamps = vpnWarningTimestamps.filter(timestamp => now - timestamp < oneMonth);

		// Check if we've shown it today (within last 24 hours)
		const lastShown = vpnWarningTimestamps.length > 0 
			? Math.max(...vpnWarningTimestamps) 
			: 0;
		const shownToday = now - lastShown < oneDay;

		// Check if we've shown it 10 times this month
		const show10xThisMonth = vpnWarningTimestamps.length >= 10;

		// Show message only if not shown today and not reached monthly limit
		if (!shownToday && !show10xThisMonth) {
			toasts.error('We recommend disconnecting from your VPN while using the app', 2500);
			
			// Add current timestamp
			vpnWarningTimestamps.push(now);
			
			// Save back to localStorage
			try {
				localStorage.setItem('vpnWarningTimestamps', JSON.stringify(vpnWarningTimestamps));
			} catch (e) {
				console.error('Error saving vpnWarningTimestamps to localStorage:', e);
			}
		}
	};
	componentDidMount = () => {
		setTimeout(this.ensureFramework7StatusBarClass, 100); // fix framework 7 bug
		window.addEventListener('touchstart', this.ensureFramework7StatusBarClass, { once: true });

		// flush any queued error logs from previous sessions
		mainAPI?.error_log?.flushQueue && mainAPI.error_log.flushQueue();

		listenForInteraction.onInteraction(() => {
			localStorage.last_log_in = Date.now();
		});
		document.addEventListener('resume', this.appResume, false);
		document.addEventListener('resume', () => { mainAPI?.error_log?.flushQueue && mainAPI.error_log.flushQueue(); }, false);
		document.addEventListener('chcp_updateIsReadyToInstall', this.showHotUpdateToast, false);
		// toasts.show('localStorage.updating', localStorage.updating);
		// this.showUpToDateToast();
		setTimeout(() => {
			if (navigator && navigator.splashscreen && navigator.splashscreen.hide) navigator.splashscreen.hide();
		}, 1000);
		document.fonts.load('16px "Helvetica Neue"').then(() => {
			console.log('main-font-loaded')
			document.body.classList.remove('main-font-loading')
		});
		document.fonts.load('16px "untitled-font-1"').then(() => {
			console.log('icon-font-loaded')
			document.body.classList.remove('icon-font-loading')
		});
	};
	 ensureFramework7StatusBarClass = () => {
		const isStandalone = window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone;
		if (isStandalone) {
			document.documentElement.classList.add('with-statusbar');
		}
	}
	showHotUpdateToast = () => {
		localStorage.updating = true;
		toasts.show('Updating to new version');
	};

	showUpToDateToast = () => {
		if (!localStorage.updating) return;
		setTimeout(() => {
			delete localStorage.updating;
			toasts.show('Update installed. You are now on the latest version.', 3000);
		}, 3000);
	};

	render() {
		this.showUpToDateToast();
		return (
			<App
				params={{ theme: 'ios', routes, name: 'LogRx', id: 'com.logrx.main' }}
				ref={(ref) => {
					if (!window.f7) window.f7 = ref.$f7;
				}}
			>
				<Statusbar />
				<LeftPanel />
				<PopupController ref={(ref) => (window.popupController = ref)} />
				<ToastController ref={(ref) => (window.toastController = ref)} />
				<MainViews />
				<AppPopup />
				<ResetPasswordPopup />
				<LoginPopup />
			</App>
		);
	}
}

export default APP;
